import { useState } from 'react';

type SegmentedControlProps = {
    segments: string[];
    segmentsSpan?: string[];
    segmentsImage?: any;
    selectedSegmentIndex?: number;
    onSegmentChanged?: (segment: number) => void;
    additionalClasses?: string;
};
export default function SegmentedControlMini({
    segments,
    segmentsSpan = [],
    segmentsImage = [] as any,
    selectedSegmentIndex = 0,
    additionalClasses = '',
    onSegmentChanged = (index) => {},
}: SegmentedControlProps) {
    const [selectedIndex, setSelectedIndex] = useState(selectedSegmentIndex);
    const handleClick = (index: number) => {
        setSelectedIndex(index);
        onSegmentChanged(index);
    };
    return (
        <div
            style={{ maxWidth: '200px', margin: '0px 0px 20px 0px' }}
            className={
                additionalClasses +
                ' ' +
                'segmented-control-mini segmented-control-' +
                segments.length
            }
        >
            {segments.map((segment, index) => (
                <div
                    className={
                        index == selectedIndex
                            ? 'segmented-control-segment active'
                            : 'segmented-control-segment'
                    }
                    onClick={handleClick.bind(null, index)}
                    key={index}
                >
                    {segment}
                    {!!segmentsImage[index] && (
                        <div className="segment-image">
                            <img
                                className="inactive"
                                src={`/images/${segmentsImage[index].inactive}`}
                                alt="icon"
                            />
                            <img
                                className="active"
                                src={`/images/${segmentsImage[index].active}`}
                                alt="icon"
                            />
                        </div>
                    )}
                    {!!segmentsSpan[index] && (
                        <span style={{ fontSize: 13 }}>{segmentsSpan[index]}</span>
                    )}
                </div>
            ))}
        </div>
    );
}
